import styled from "styled-components";

import { mobileOnly } from "_/style/media";
import { pagePadding } from "_/style/layout";

import { Table as _Table } from "_/components/table";
import { Link as _Link } from "_/components/router";
import { MachineCameraMedia as _MachineCameraMedia } from "_/components/machine-camera-media";
import { Icon as _Icon } from "_/components/icon";
import { MachineTemperatureDisplay as _MachineTemperatureDisplay } from "_/components/machine-temperature-display";
import { CopyableCode as _CopyableCode } from "_/components/copyable-code";
import * as HomeDashboardS from "_/components/home-dashboard/styled";
import { VersionWrapper } from "_/components/machine-listing/styled";

export const CopyableCode = styled(_CopyableCode)`
  margin-top: 1rem;
`;

export const WidgetTitleContainer = styled(
  HomeDashboardS.HomeWidgetTitleContainer
)`
  min-height: 2.25rem;
`;

export const TemperatureHeading = styled.h2`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const TemperatureHeadingSubtext = styled.span`
  font-size: 0.875rem;
  color: ${(p) => p.theme.button.warning.default};
  padding-left: 0.375rem;
`;

export const WarningIcon = styled(_Icon)`
  margin-left: 0.5rem;
  font-size: 1.25rem;
  color: ${(p) => p.theme.button.warning.default};
`;

export const Widget = HomeDashboardS.HomeWidget;
export const NestedWidgetContainer = HomeDashboardS.NestedWidgetContainer;
export const UseRemainingWidth = HomeDashboardS.UseRemainingWidth;

export const Wrapper = styled.div`
  height: 100%;
`;

export const TemperatureWidget = styled.div`
  display: flex;
  flex-direction: column;

  padding: 1.25rem;
  gap: 1.25rem;

  background-color: ${(p) => p.theme.background.secondary};
  border-radius: 8px;
`;

export const MachineOverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  color: ${(p) => p.theme.text.default};
  gap: 2.25rem;
  ${pagePadding};
`;

export const Link = styled(_Link)`
  margin-left: auto;
  color: ${(p) => p.theme.link.default};
`;

export const MachineInfo = styled.div`
  display: flex;
  gap: 3rem;
  margin-top: 1rem;
`;

export const MachineConfigurationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  & ${CopyableCode} {
    margin-top: 0.125rem;
  }
`;

export const MachineInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  font-size: 0.875rem;
  gap: 0.375rem;
`;

export const MachineInfoLabel = styled.label`
  color: ${(p) => p.theme.text.muted};
`;

export const MachineInfoValue = styled.span`
  color: ${(p) => p.theme.text.default};
`;

export const MachineInfoLabelRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
`;

export const IconLink = styled(_Icon)`
  font-size: 1rem;
  cursor: pointer;
  color: ${(p) => p.theme.link.default};
`;

export const HorizontalList = styled.div`
  display: flex;
  gap: 3rem;
  ${mobileOnly`
    flex-direction: column;
  `}
`;

export const HorizontalListSeparator = styled.span`
  &::before {
    color: ${(p) => p.theme.text.muted};
    content: "|";
    margin: 0 1rem;
  }
`;

export const LastMachineImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
  width: 320px;
  max-width: 100%;
  align-items: center;
  justify-content: center;
  color: ${(p) => p.theme.text.muted};
`;

export const ImageTimestamp = styled.div`
  height: 1.25rem;
  line-height: 1.25rem;
`;

export const UnavailableImageMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 180px;
  flex-shrink: 0;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  background-color: ${(p) => p.theme.background.secondary};
`;

export const Image = styled(_MachineCameraMedia)`
  width: 100%;
  height: 180px;
  flex-shrink: 0;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  background-color: ${(p) => p.theme.background.secondary};
`;

export const MachineOverviewInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.875rem;
`;

export const MachineOverviewLabel = styled.label`
  color: ${(p) => p.theme.text.muted};
`;

export const ModalText = styled.p`
  font-size: 0.875rem;
  margin-bottom: 0.75em;
`;

export const MachineTemperatureDisplay = styled(_MachineTemperatureDisplay)`
  height: calc(200px - 1.25rem);
  align-content: center;
  overflow-x: auto;
`;

export { VersionWrapper };
